module.exports = __webpack_public_path__ + "static/avatar-54930ec7030d0f0846d19583e656535e.jpg";